jQuery(document).ready(function($) {

    $('div.switches').find('input[type="radio"]').on('change', function(event) {

        var switchSelector = $(this).attr('name');
        var switchValue = $(this).val();

        $('div[data-switch-values="'+switchSelector+'"]').children('div').hide();
        $('div[data-switch-values="'+switchSelector+'"]').find('div[data-switch-value="'+switchValue+'"]').show();

    });


    $('div.switches').find('input[type="checkbox"]').parent('label').on('mouseover', function(event) {
        var switchSelector = $(this).find('input[type="checkbox"]').attr('name');
        var switchValue = $(this).find('input[type="checkbox"]').val();
        $(this).parents('fieldset:first').find('.explanation').children('div').hide();
        // $('div[data-switch-values="'+switchSelector+'"]').children('div').hide();
        $(this).parents('fieldset:first').find('.explanation').find('div[data-switch-value="'+switchSelector+'"]').show();
    });

    $('div.switches').find('input[type="checkbox"]').parent('label').on('mouseout', function(event) {
        var switchSelector = $(this).find('input[type="checkbox"]').attr('name');
        // $('div[data-switch-values="'+switchSelector+'"]').children('div').hide();
        $(this).parents('fieldset:first').find('.explanation').children('div').hide();
        $(this).parents('fieldset:first').find('.explanation').children('div[data-switch-value="x"]').show();
        // $('div[data-switch-values="'+switchSelector+'"]').find('div[data-switch-value="x"]').show();
    });

    //show the 'starting' switch value
    $('div.switches').find('input[type="radio"]:checked').trigger('change');

});